var _circle, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUseMyFrame2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 42,
    viewBox: "0 0 43 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.8355,
    cy: 24.2926,
    r: 11.9916,
    stroke: "white",
    strokeWidth: 2.352
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 29.6363,
    cy: 17.7076,
    r: 11.9916,
    stroke: "white",
    strokeWidth: 2.352
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUseMyFrame2);
export default __webpack_public_path__ + "static/media/use_my_frame2.161dadbf7714e33636f9b071a9196e0d.svg";
export { ForwardRef as ReactComponent };